import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import api from 'config/api';
import Storage from 'lib/Storage';
import { RootState } from 'store/store';
import { MessageArray } from 'types/message';

export interface InboxState {
  status: 'idle' | 'loading' | 'successed' | 'error';
  entities: MessageArray;
}

const initialState: InboxState = {
  entities: [],
  status: 'idle',
};

// Initialize storage library
let storage = new Storage();

export const fetchLatestMessages = createAsyncThunk(
  'inbox/fetchLatestMessages',
  async () => {
    const response = await fetch(api.inbox.latest, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${storage.get('token')}`,
      },
    });
    return await response.json();
  }
);

export const inboxSlice = createSlice({
  name: 'inbox',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLatestMessages.pending, (state) => {
      state.status = 'loading';
    });

    builder.addCase(fetchLatestMessages.fulfilled, (state, action) => {
      state.status = 'successed';
      state.entities = action.payload.data;
    });
  },
});

export const inboxSelector = (state: RootState) => state.inbox;

export default inboxSlice.reducer;
